export const recipesData = [
  {
    id: 1,
    name: 'Soup',
    yield: 2,
    calories: 523,
    protein: 30,
    fat: 20,
    carbs: 55,
    fiber: 6,
    saturatedFat: 4,
    transFat: 0,
    cholesterol: 94,
    sugar: 3,
    sodium: 388,
    ingredients: [
      {
        fat: 0.6747,
        name: 'potato',
        unit: 'potato medium',
        carbs: 109.7685,
        fiber: 11.418,
        sugar: 6.1242,
        sodium: 51.900000000000006,
        options: [
          {
            qty: 1,
            seq: 1,
            measure: 'NLEA serving',
            serving_weight: 148,
          },
          {
            qty: 1,
            seq: 4,
            measure: 'potato small',
            serving_weight: 138,
          },
          {
            qty: 1,
            seq: 3,
            measure: 'potato medium',
            serving_weight: 173,
          },
          {
            qty: 1,
            seq: 2,
            measure: 'potato large',
            serving_weight: 299,
          },
          {
            qty: 1,
            seq: 80,
            measure: 'cup',
            serving_weight: 122,
          },
          {
            qty: 100,
            seq: null,
            measure: 'g',
            serving_weight: 100,
          },
          {
            qty: 1,
            seq: null,
            measure: 'wt. oz',
            serving_weight: 28.3495,
          },
          {
            qty: 1,
            seq: 101,
            measure: 'tsp',
            serving_weight: 2.54,
          },
          {
            qty: 1,
            seq: 102,
            measure: 'tbsp',
            serving_weight: 7.63,
          },
        ],
        protein: 12.975000000000001,
        calories: 482.66999999999996,
        quantity: 3,
        transFat: 0,
        brandName: null,
        nixItemId: null,
        cholesterol: 0,
        thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/752_thumb.jpg',
        highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/752_highres.jpg',
        saturatedFat: 0.1764,
        servingWeight: 173,
      },
      {
        fat: 26.14,
        name: 'chicken',
        unit: 'g',
        carbs: 0.1,
        fiber: 0,
        sugar: 0,
        sodium: 142,
        options: [
          {
            qty: 3,
            seq: 1,
            measure: 'oz',
            serving_weight: 85,
          },
          {
            qty: 1,
            seq: 2,
            measure: 'unit (yield from 1 lb ready-to-cook chicken)',
            serving_weight: 235,
          },
          {
            qty: 1,
            seq: 3,
            measure: 'chicken',
            serving_weight: 1072,
          },
          {
            qty: 1,
            seq: 80,
            measure: 'cup',
            serving_weight: 135,
          },
          {
            qty: 100,
            seq: null,
            measure: 'g',
            serving_weight: 100,
          },
          {
            qty: 1,
            seq: 101,
            measure: 'tsp',
            serving_weight: 2.81,
          },
          {
            qty: 1,
            seq: 102,
            measure: 'tbsp',
            serving_weight: 8.44,
          },
        ],
        protein: 47.919999999999995,
        calories: 440.00000000000006,
        quantity: 200,
        transFat: 0,
        brandName: null,
        nixItemId: null,
        cholesterol: 188,
        thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/9_thumb.jpg',
        highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/9_highres.jpg',
        saturatedFat: 7.32,
        servingWeight: 85,
      },
      {
        fat: 14,
        name: 'oil',
        unit: 'tbsp',
        carbs: 0,
        fiber: 0,
        sugar: 0,
        sodium: 0,
        options: [
          {
            qty: 1,
            seq: 1,
            measure: 'tbsp',
            serving_weight: 14,
          },
          {
            qty: 100,
            seq: null,
            measure: 'g',
            serving_weight: 100,
          },
          {
            qty: 1,
            seq: null,
            measure: 'wt. oz',
            serving_weight: 28.3495,
          },
          {
            qty: 1,
            seq: 100,
            measure: 'cup',
            serving_weight: 224,
          },
          {
            qty: 1,
            seq: 101,
            measure: 'tsp',
            serving_weight: 4.67,
          },
        ],
        protein: 0,
        calories: 123.76,
        quantity: 1,
        transFat: 0.1074,
        brandName: null,
        nixItemId: null,
        cholesterol: 0,
        thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/1031_thumb.jpg',
        highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/1031_highres.jpg',
        saturatedFat: 0.9115,
        servingWeight: 14,
      },
      {
        fat: 0,
        name: 'salt',
        unit: 'tsp',
        carbs: 0,
        fiber: 0,
        sugar: 0,
        sodium: 581.37,
        options: [
          {
            qty: 1,
            seq: 4,
            measure: 'dash',
            serving_weight: 0.4,
          },
          {
            qty: 1,
            seq: 1,
            measure: 'tsp',
            serving_weight: 6,
          },
          {
            qty: 100,
            seq: null,
            measure: 'g',
            serving_weight: 100,
          },
          {
            qty: 1,
            seq: null,
            measure: 'wt. oz',
            serving_weight: 28.3495,
          },
          {
            qty: 1,
            seq: 100,
            measure: 'cup',
            serving_weight: 288,
          },
          {
            qty: 1,
            seq: 102,
            measure: 'tbsp',
            serving_weight: 18,
          },
        ],
        protein: 0,
        calories: 0,
        quantity: 0.25,
        transFat: 0,
        brandName: null,
        nixItemId: null,
        cholesterol: 0,
        thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/177_thumb.jpg',
        highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/177_highres.jpg',
        saturatedFat: 0,
        servingWeight: 1.5,
      },
    ],
  },
];

export const newRecipe = {
  id: 22,
  calories: 222,
  protein: 15,
  fat: 9,
  carbs: 19,
  fiber: 1,
  saturatedFat: 3,
  transFat: 0,
  cholesterol: 37,
  sugar: 0,
  sodium: 27,
  name: 'Lasagna',
  yield: 2,
  ingredients: [
    {
      fat: 1.1532,
      name: 'pasta',
      unit: 'cup spaghetti not packed',
      carbs: 38.2664,
      fiber: 2.232,
      sugar: 0.6944,
      sodium: 1.24,
      options: [
        {
          qty: 1,
          seq: 1,
          measure: 'cup spaghetti not packed',
          serving_weight: 124,
        },
        {
          qty: 1,
          seq: 80,
          measure: 'lasagna noodle (cooked)',
          serving_weight: 57,
        },
        {
          qty: 1,
          seq: 81,
          measure: 'cup ziti',
          serving_weight: 107,
        },
        {
          qty: 1,
          seq: 82,
          measure: 'cup linguine',
          serving_weight: 135,
        },
        {
          qty: 1,
          seq: 83,
          measure: 'cup capellini',
          serving_weight: 135,
        },
        {
          qty: 1,
          seq: 84,
          measure: 'cup',
          serving_weight: 140,
        },
        {
          qty: 100,
          seq: null,
          measure: 'g',
          serving_weight: 100,
        },
        {
          qty: 1,
          seq: null,
          measure: 'wt. oz',
          serving_weight: 28.3495,
        },
        {
          qty: 1,
          seq: 101,
          measure: 'tsp',
          serving_weight: 2.92,
        },
        {
          qty: 1,
          seq: 102,
          measure: 'tbsp',
          serving_weight: 8.75,
        },
      ],
      protein: 7.192,
      calories: 195.92,
      quantity: 1,
      transFat: 0,
      brandName: null,
      nixItemId: null,
      cholesterol: 0,
      thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/1012_thumb.jpg',
      highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/1012_highres.jpg',
      saturatedFat: 0.2182,
      servingWeight: 124,
    },
  ],
  createdBy: 173,
  updatedBy: 173,
  patientId: 109,
  updatedAt: '2021-11-04T08:12:16.803Z',
  createdAt: '2021-11-04T08:12:16.803Z',
};
export const loggingFood = [
  {
    name: 'pasta',
    nixItemId: null,
    quantity: 1,
    unit: 'cup spaghetti not packed',
    thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/1012_thumb.jpg',
    calories: 195.92,
    protein: 7.192,
    fat: 1.1532,
    carbs: 38.2664,
    fiber: 2.232,
    saturatedFat: 0.2182,
    transFat: 0,
    cholesterol: 0,
    sugar: 0.6944,
    sodium: 1.24,
    options: [],
    servingWeight: 124,
  },
  {
    name: 'Half and Half',
    brandName: 'Land O Lakes',
    nixItemId: '51c3719f97c3e69de4b0afb1',
    quantity: 2,
    unit: 'tbsp',
    thumbImgUrl: 'https://nutritionix-api.s3.amazonaws.com/5e2beb8c616a83bb1b9dfd1a.jpeg',
    calories: 40,
    protein: 0.5,
    fat: 3,
    carbs: 1,
    fiber: 0,
    saturatedFat: 2,
    transFat: 0,
    cholesterol: 10,
    sugar: 1,
    sodium: 15,
    options: [],
    servingWeight: null,
  },
  {
    name: 'Ranch Snack Mix',
    brandName: 'Parm Crisps',
    nixItemId: '5ff07b2011615a552e9b42e2',
    quantity: 0.25,
    unit: 'cup',
    thumbImgUrl: 'https://nutritionix-api.s3.amazonaws.com/5ff07b2511615a552e9b42e3.jpeg',
    calories: 170,
    protein: 9,
    fat: 13,
    carbs: 6,
    fiber: 3,
    saturatedFat: 3.5,
    transFat: 0,
    cholesterol: 10,
    sugar: 1,
    sodium: 150,
    options: [],
    servingWeight: 30,
  },
];

export const pastaNutrients = {
  name: 'pasta',
  brandName: null,
  nixItemId: null,
  quantity: 1,
  unit: 'cup spaghetti not packed',
  thumbImgUrl: 'https://nix-tag-images.s3.amazonaws.com/1012_thumb.jpg',
  highImageUrl: 'https://nix-tag-images.s3.amazonaws.com/1012_highres.jpg',
  calories: 195.92,
  protein: 7.192,
  fat: 1.1532,
  carbs: 38.2664,
  fiber: 2.232,
  saturatedFat: 0.2182,
  transFat: 0,
  cholesterol: 0,
  sugar: 0.6944,
  sodium: 1.24,
  options: [
    {
      serving_weight: 124,
      measure: 'cup spaghetti not packed',
      seq: 1,
      qty: 1,
    },
    {
      serving_weight: 57,
      measure: 'lasagna noodle (cooked)',
      seq: 80,
      qty: 1,
    },
    {
      serving_weight: 107,
      measure: 'cup ziti',
      seq: 81,
      qty: 1,
    },
    {
      serving_weight: 135,
      measure: 'cup linguine',
      seq: 82,
      qty: 1,
    },
    {
      serving_weight: 135,
      measure: 'cup capellini',
      seq: 83,
      qty: 1,
    },
    {
      serving_weight: 140,
      measure: 'cup',
      seq: 84,
      qty: 1,
    },
    {
      serving_weight: 100,
      measure: 'g',
      seq: null,
      qty: 100,
    },
    {
      serving_weight: 28.3495,
      measure: 'wt. oz',
      seq: null,
      qty: 1,
    },
    {
      serving_weight: 2.92,
      measure: 'tsp',
      seq: 101,
      qty: 1,
    },
    {
      serving_weight: 8.75,
      measure: 'tbsp',
      seq: 102,
      qty: 1,
    },
  ],
  servingWeight: 124,
};

export const brandedFoodHalfNutrients = {
  name: 'Half and Half',
  brandName: 'Land O Lakes',
  nixItemId: '51c3719f97c3e69de4b0afb1',
  quantity: 1,
  unit: 'tbsp',
  thumbImgUrl: 'https://nutritionix-api.s3.amazonaws.com/5e2beb8c616a83bb1b9dfd1a.jpeg',
  highImageUrl: null,
  calories: 20,
  protein: 0.25,
  fat: 1.5,
  carbs: 0.5,
  fiber: 0,
  saturatedFat: 1,
  transFat: 0,
  cholesterol: 5,
  sugar: 0.5,
  sodium: 7.5,
  options: [],
  servingWeight: null,
};
export const brandedFoodHalfSearch = {
  name: 'Half and Half',
  brandName: 'Land O Lakes',
  nixItemId: '51c3719f97c3e69de4b0afb1',
  quantity: 2,
  unit: 'tbsp',
  thumbImgUrl: 'https://nutritionix-api.s3.amazonaws.com/5e2beb8c616a83bb1b9dfd1a.jpeg',
  calories: 40,
  protein: 0.5,
  fat: 3,
  carbs: 1,
  fiber: 0,
  saturatedFat: 2,
  transFat: 0,
  cholesterol: 10,
  sugar: 1,
  sodium: 15,
  options: [],
  servingWeight: null,
};
export const brandedFoodRanchSearch = {
  name: 'Ranch Snack Mix',
  brandName: 'Parm Crisps',
  nixItemId: '5ff07b2011615a552e9b42e2',
  quantity: 0.25,
  unit: 'cup',
  thumbImgUrl: 'https://nutritionix-api.s3.amazonaws.com/5ff07b2511615a552e9b42e3.jpeg',
  calories: 170,
  protein: 9,
  fat: 13,
  carbs: 6,
  fiber: 3,
  saturatedFat: 3.5,
  transFat: 0,
  cholesterol: 10,
  sugar: 1,
  sodium: 150,
  options: [],
  servingWeight: 30,
};
export const brandedFoodRanchNutrients = {
  name: 'Ranch Snack Mix',
  brandName: 'Parm Crisps',
  nixItemId: '5ff07b2011615a552e9b42e2',
  quantity: 1,
  unit: 'cup',
  thumbImgUrl: 'https://nutritionix-api.s3.amazonaws.com/5ff07b2511615a552e9b42e3.jpeg',
  highImageUrl: null,
  calories: 680,
  protein: 36,
  fat: 52,
  carbs: 24,
  fiber: 12,
  saturatedFat: 14,
  transFat: 0,
  cholesterol: 40,
  sugar: 4,
  sodium: 600,
  options: [],
  servingWeight: 30,
};
